<!--  -->
<template>
  <div class="main">
    <!-- 左边图标 -->
    <div
      class="icon_box"
      :class="jumpSource === 'model' ? 'model_icon' : ''"
      @click="handleTreeOpen"
      v-if="rowId || fileId"
    >
      <img src="@/assets/images/tree_gray.png" alt="" />
    </div>
    <!-- 左边信息 -->
    <div
      v-drag
      class="main_left"
      :class="jumpSource === 'model' ? 'model_main_left' : ''"
      v-show="treeActivated"
    >
      <!-- 标题 -->
      <div class="title_box">
        <div class="title">{{ $t("directory_tree") }}</div>
        <i class="el-icon-close" @click="handleTreeClose"></i>
      </div>
      <!-- 搜索 -->
      <el-input
        placeholder="请输入关键词"
        prefix-icon="el-icon-search"
        v-model="filterText"
      >
      </el-input>
      <!-- 树状 -->
      <div class="tree_box">
        <el-tree
          :data="treeData"
          ref="treeDataRef"
          show-checkbox
          default-expand-all
          node-key="Index"
          :props="defaultProps"
          @node-click="handleNodeClick"
          :filter-node-method="filterNode"
          @check="handleCheck"
          empty-text="加载中"
        >
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>
              <img
                class="tree_model"
                src="@/assets/images/tree_model.png"
                alt=""
              />
              <span
                @click="handleIsActive(node.label, data.Index)"
                :class="[isActive === data.Index ? 'light_blue' : '']"
              >
                {{ node.label }}</span
              >
            </span>
          </span>
        </el-tree>
      </div>
    </div>
    <!-- 右边信息 -->
    <!-- 提示信息 -->
    <div
      v-drag
      class="main_right main_right_warning"
      :class="jumpSource ? 'model_main_right' : ''"
      v-show="warningActivated"
    >
      <!-- 标题 -->
      <div class="title_box">
        <div class="title">{{ $t("object_detail") }}</div>
        <i class="el-icon-close" @click="handleWarningClose"></i>
      </div>
      <!-- 请选择一个构件，以查看对应属性 -->
      <div class="nodata nodata_warning">
        <i class="el-icon-warning"></i>
        <div>{{ $t("object_warning") }}</div>
      </div>
    </div>
    <!-- 构件信息 -->
    <div
      v-drag
      class="main_right"
      :class="jumpSource ? 'model_main_right' : ''"
      v-show="listActivated"
    >
      <!-- 标题 -->
      <div class="title_box">
        <div class="title">{{ $t("object_detail") }}</div>
        <i class="el-icon-close" @click="handleListClose"></i>
      </div>
      <!-- 选项卡 -->
      <div class="tab_box">
        <div
          @click="changeTab(idx)"
          v-for="(item, idx) in tabArr"
          :key="idx"
          :class="tabSelected === idx ? 'tab_selected' : ''"
        >
          {{ item.name }}
        </div>
      </div>
      <!-- 列表 -->
      <div class="list_box">
        <el-collapse v-model="activeNames">
          <!-- 有Section数据 -->
          <template v-if="Section">
            <!-- 断面/支护-->
            <template v-if="objSelected && tabParams">
              <el-collapse-item
                :name="index"
                v-for="(val, key, index) in tabParams"
                :key="key"
              >
                <span class="collapse-title" slot="title">{{ key }}</span>
                <div
                  class="list_item"
                  v-for="item in val.Item"
                  :key="item.PropertyName"
                >
                  <div class="list_name">{{ item.PropertyName }}</div>
                  <div class="list_text">{{ item.text }}</div>
                </div>
              </el-collapse-item>
            </template>
            <!-- 基础/环境 -->
            <template v-else-if="arrSelected && tabParams">
              <div
                class="list_item table_item"
                :name="index"
                v-for="(item, index) in tabParams.Item"
                :key="item.PropertyName"
              >
                <div class="list_name table_name">{{ item.PropertyName }}</div>
                <div class="list_text table_text">{{ item.text }}</div>
              </div>
            </template>
            <!-- Section内无数据 -->
            <template v-else>
              <div class="nodata">{{ $t("no_data") }}</div>
            </template>
          </template>
          <!-- 没Section数据 -->
          <template v-else>
            <div class="nodata">{{ $t("no_data") }}</div>
          </template>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
const request = axios.create();
request.defaults.withCredentials = true;
request.interceptors.request.use(
  function (config) {
    return config;
  },
  function () {
    return Promise.reject(error);
  }
);
//===========================
import api from "../../url/api";
export default {
  name: "",
  props: ["rowId", "fileId", "jumpSource", "queryInfo"],
  // 自定义指令 实现可拖动
  directives: {
    drag(el, bindings) {
      el.onmousedown = function (e) {
        var disx = e.pageX - el.offsetLeft;
        var disy = e.pageY - el.offsetTop;
        document.onmousemove = function (e) {
          el.style.left = e.pageX - disx + "px";
          el.style.top = e.pageY - disy + "px";
        };
        document.onmouseup = function () {
          document.onmousemove = document.onmouseup = null;
        };
      };
    },
  },
  data() {
    return {
      tabSelected: null,
      objSelected: false,
      arrSelected: false,
      activeNames: ["1"],
      isActive: null,
      treeActivated: false,
      listActivated: false,
      warningActivated: false,
      filterText: "",
      tabArr: [
        { name: "基础" },
        { name: "断面" },
        { name: "支护" },
        { name: "环境" },
      ],
      data: {},
      treeData: [],
      SecParams: [],
      Section: [], //important
      tabParams: {}, //基础，断面，支护，环境
      itemParams: {}, //支护中的Item
      rail: {},
      railItem: [],
      nameArr: [], //objectId清除 重现
      selectArr: [], //构件多选选中
      beforeArr: [],
      afterData: [],
      // allNameArr:[],//含有所有name的arr
      // children和label 与接口字段保持一致
      single: false,
      double: false,
      defaultProps: {
        children: "children",
        label: "Name",
      },
      newMerge: true, //第一次merge
      newMerge2: true, //支护
    };
  },
  created() {
    // console.log("modelDetail");
    // console.log(this.rowId);
    // console.log(this.fileId);
    // console.log(this.jumpSource);
  },
  mounted() {},
  watch: {
    filterText(val) {
      this.$refs.treeDataRef.filter(val.trim());
    },
    rowId(newVal, oldVal) {
      this.rowId = newVal;
    },
    fileId(newVal, oldVal) {
      this.fileId = newVal;
    },
  },
  methods: {
    __init() {
      if (this.treeData.length < 1) {
        if (this.jumpSource === "model") {
          var url = api.file_mim_treeFormat.url + this.fileId;
        } else if (this.jumpSource === "deliverData") {
          var url = api.file_mim_tree_deliverData.url;
        } else {
          var url = api.file_mim_tree.url + this.rowId;
        }
        request
          .get(url, {
            params: this.queryInfo,
          })
          .then((resp) => {
            if (resp.data.code == 200) {
              this.treeData = resp.data.tree;
              // console.log(this.treeData);
              this.$nextTick(() => {
                this.$refs.treeDataRef.setCheckedNodes(this.treeData);
              });
              this.nameArr = []; //选中的id数组
              this.recursionName(this.treeData);
              // console.log("一开始的Name", this.nameArr);
              this.$emit("allName", this.nameArr);
            } else {
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    //复选框
    handleCheck(data, selected) {
      // console.log(this.treeData);
      this.nameArr = []; //选中的id数组
      // console.log(selected.checkedNodes);
      this.recursionName(selected.checkedNodes);
      this.nameArr = Array.from(new Set(this.nameArr));
      this.$emit("selectedName", this.nameArr);
    },
    //递归children 取消或隐藏构件
    recursionName(arr) {
      arr.map((item) => {
        if (item.children.length < 1) {
          let num = Number(item.Name);
          if (!isNaN(num)) {
            //字符串能转为数字
            // console.log(item.Name)
            this.nameArr.push(item.Name);
          }
        } else {
          this.recursionName(item.children);
        }
      });
    },
    //tabs
    changeTab(index) {
      this.tabSelected = index;
      this.enterData = true;
      switch (index) {
        case 0: //基础
          this.tabParams = JSON.parse(
            JSON.stringify(this.Section.Basic.BasicPara)
          );
          // console.log("基础", this.tabParams);
          if (this.tabParams.Item) {
            this.tabParams.Item.forEach((item) => {
              switch (item.PropertyName) {
                case "SecName":
                  item.PropertyName = "断面名称";
                  break;
                case "TUCeng":
                  item.PropertyName = "图层";
                  break;
                case "BSecType":
                  item.PropertyName = "断面类型";
                  break;
              }
            });
          }
          if (this.tabParams.Item) {
            let filterData = this.tabParams.Item.filter((item) => {
              if (
                item.PropertyName === "断面名称" ||
                item.PropertyName === "图层" ||
                item.PropertyName === "断面类型"
              ) {
                return item;
              }
            });
            this.tabParams.Item = filterData;
          }
          // console.log('0',this.tabParams)
          this.objSelected = false;
          this.arrSelected = true;
          break;
        case 1: //断面
          this.tabParams = this.Section.SecParams;
          //判断是否有轨道 和单双轨道修改
          if (this.tabParams.Rail) {
            this.tabParams.Rail.Item.some((item) => {
              if (item.PropertyName === "IsSetRail" && item.text === "False") {
                delete this.tabParams.Rail;
                // console.log("删除了Rail,剩下的tabParams", this.tabParams);
                return true;
              }
              if (item.PropertyName === "IsSingle" && item.text === "True") {
                //单轨道
                this.single = true;
              }
            });
            if (this.single) {
              //单轨道 删除双轨道信息
              this.tabParams.Rail.Item = this.tabParams.Rail.Item.filter(
                (item) => item.PropertyName != "GZ_GD2"
              );
              this.tabParams.Rail.Item = this.tabParams.Rail.Item.filter(
                (item) => item.PropertyName != "SBKD_GD2"
              );
              this.tabParams.Rail.Item = this.tabParams.Rail.Item.filter(
                (item) => item.PropertyName != "AQJXb3_GD2"
              );
              this.tabParams.Rail.Item = this.tabParams.Rail.Item.filter(
                (item) => item.PropertyName != "GZJJ_GD2"
              );
              this.single = false;
            }
          }
          if (this.tabParams.Rail) {
            this.tabParams.Rail.Item.forEach((item) => {
              switch (item.PropertyName) {
                case "RailType":
                  item.PropertyName = "轨道形式（单轨or双轨）";
                  break;
                case "GZ_GD1":
                  item.PropertyName = "轨重—轨道1";
                  break;
                case "GJ_GD1":
                  item.PropertyName = "轨距b—轨道1";
                  break;
                case "GMG_GD1":
                  item.PropertyName = "轨面高h1—轨道1";
                  break;
                case "GZJJ_GD1":
                  item.PropertyName = "轨枕间距—轨道1";
                  break;
                case "JXGD_GD1":
                  item.PropertyName = "架线高度h3—轨道1";
                  break;
                case "SBKD_GD1":
                  item.PropertyName = "设备宽度L1—轨道1";
                  break;
                case "SBGD_GD1":
                  item.PropertyName = "设备高度h2—轨道1";
                  break;
                case "AQJXb1_GD1":
                  item.PropertyName = "安全间隙b1—轨道1";
                  break;
                case "AQJXb2_GD1":
                  item.PropertyName = "安全间隙b2—轨道1";
                  break;
                case "GZ_GD2":
                  item.PropertyName = "轨重—轨道2";
                  break;
                case "SBKD_GD2":
                  item.PropertyName = "设备宽度L2—轨道2";
                  break;
                case "AQJXb3_GD2":
                  item.PropertyName = "安全间隙b3—轨道2";
                  break;
                case "GZJJ_GD2":
                  item.PropertyName = "轨枕间距—轨道2";
                  break;
              }
            });
            //过滤
            this.tabParams.Rail.Item = this.tabParams.Rail.Item.filter(
              (item) => item.PropertyName != "IsSetRail"
            );
            this.tabParams.Rail.Item = this.tabParams.Rail.Item.filter(
              (item) => item.PropertyName != "IsSingle"
            );
            this.tabParams.Rail.Item = this.tabParams.Rail.Item.filter(
              (item) => item.PropertyName != "IsDouble"
            );
          }
          if (this.tabParams.CalResults) {
            this.tabParams.CalResults.Item.forEach((item) => {
              switch (item.PropertyName) {
                case "JMJ":
                  item.PropertyName = "净面积";
                  break;
                case "JJMJ":
                  item.PropertyName = "掘进面积";
                  break;
                case "JZC":
                  item.PropertyName = "净周长";
                  break;
                case "JJZC":
                  item.PropertyName = "掘进周长";
                  break;
                case "GG_SEC":
                  item.PropertyName = "拱高";
                  break;
                case "ZQG_SEC":
                  item.PropertyName = "直墙高";
                  break;
                case "SecName":
                  item.PropertyName = "断面名称";
                  break;
                case "TUCeng":
                  item.PropertyName = "图层";
                  break;
                case "BSecType":
                  item.PropertyName = "断面类型";
                  break;
                case "InvertShape":
                  item.PropertyName = "拱形";
                  break;
                case "JwithB":
                  item.PropertyName = "净宽度B";
                  break;
                case "JwithH":
                  item.PropertyName = "净高度H";
                  break;
                case "DBZH":
                  item.PropertyName = "底部支护厚度";
                  break;
              }
            });
          }
          if (this.tabParams.Ginvert) {
            this.tabParams.Ginvert.Item.some((item) => {
              if (
                item.PropertyName === "IsSetGInvert" &&
                item.text === "False"
              ) {
                delete this.tabParams.Ginvert;
                return true;
              }
            });
          }
          if (this.tabParams.Ginvert) {
            this.tabParams.Ginvert.Item.forEach((item) => {
              switch (item.PropertyName) {
                case "Antiarch":
                  item.PropertyName = "反拱";
                  break;
                case "Radius":
                  item.PropertyName = "半径";
                  break;
              }
            });
            this.tabParams.Ginvert.Item = this.tabParams.Ginvert.Item.filter(
              (item) => item.PropertyName != "IsSetGInvert"
            );
          }
          if (this.tabParams.Gutter) {
            this.tabParams.Gutter.Item.some((item) => {
              if (
                item.PropertyName === "IsSetGutter" &&
                item.text === "False"
              ) {
                delete this.tabParams.Gutter;
                return true;
              }
            });
          }
          if (this.tabParams.Gutter) {
            this.tabParams.Gutter.Item.forEach((item) => {
              switch (item.PropertyName) {
                case "GSecType":
                  item.PropertyName = "水沟断面类型";
                  break;
                case "Upwith":
                  item.PropertyName = "上口宽";
                  break;
                case "DownWith":
                  item.PropertyName = "下口宽";
                  break;
                case "Gheight":
                  item.PropertyName = "高度";
                  break;
                case "GPly":
                  item.PropertyName = "支护厚度";
                  break;
                case "GPosition":
                  item.PropertyName = "水沟定位";
                  break;
              }
            });
            this.tabParams.Gutter.Item = this.tabParams.Gutter.Item.filter(
              (item) => item.PropertyName != "IsSetGutter"
            );
          }
          //key变成中文
          var keyMap = {
            CalResults: "基本参数",
            Ginvert: "水沟",
            Gutter: "底拱",
            Rail: "轨道",
          };
          var objs = Object.keys(this.tabParams).reduce((newData, key) => {
            let newKey = keyMap[key] || key;
            newData[newKey] = this.tabParams[key];
            return newData;
          }, {});
          this.tabParams = objs;
          //  console.log('1',this.tabParams)
          this.objSelected = true;
          this.arrSelected = false;
          this.showAllItems();
          break;
        case 2: //支护
          this.tabParams = this.Section.SupParams;
          // console.log("zz", this.tabParams);
          if (this.tabParams.Item) {
            let itemArr = this.tabParams.Item;
            let itemObj = new Object();
            this.$set(itemObj, "Item", itemArr); //组合
            this.$set(this.tabParams, "Sup", itemObj); //组合
            delete this.tabParams.Item;
          }
          if (this.tabParams.Sup) {
            this.tabParams.Sup.Item.forEach((item) => {
              switch (item.PropertyName) {
                case "SupForm":
                  item.PropertyName = "支护形式";
                  break;
              }
            });
            //过滤掉SupFormChecked属性
            this.tabParams.Sup.Item = this.tabParams.Sup.Item.filter(
              (item) => item.PropertyName != "SupFormChecked"
            );
          }
          var supObj = this.tabParams.Sup;
          if (this.tabParams.Sup.Item[0].text === "两次喷锚网") {
            this.tabParams = this.tabParams.SecShotAnchor;
            this.$set(this.tabParams, "Sup", supObj);
            //PT
            if (this.tabParams.PT1) {
              this.tabParams.PT1.Item.some((item) => {
                if (item.PropertyName === "IsPt1" && item.text === "False") {
                  delete this.tabParams.PT1;
                  return true;
                }
              });
              this.tabParams.PT1.Item.forEach((item) => {
                switch (item.PropertyName) {
                  case "PT_ZHHD1":
                    item.PropertyName = "喷砼支护厚度";
                    break;
                }
              });
              //过滤
              this.tabParams.PT1.Item = this.tabParams.PT1.Item.filter(
                (item) => item.PropertyName != "IsPt1"
              );
            }
            if (this.tabParams.PT2) {
              this.tabParams.PT2.Item.some((item) => {
                if (item.PropertyName === "IsPt2" && item.text === "False") {
                  delete this.tabParams.PT2;
                  return true;
                }
              });
            }
            if (this.tabParams.PT2) {
              this.tabParams.PT2.Item.forEach((item) => {
                switch (item.PropertyName) {
                  case "PT_ZHHD2":
                    item.PropertyName = "喷砼支护厚度";
                    break;
                }
              });
              //过滤
              this.tabParams.PT2.Item = this.tabParams.PT2.Item.filter(
                (item) => item.PropertyName != "IsPt2"
              );
            }
            //MG
            if (this.tabParams.MG1) {
              this.tabParams.MG1.Item.some((item) => {
                if (item.PropertyName === "IsMG1" && item.text === "False") {
                  delete this.tabParams.MG1;
                  return true;
                }
              });
            }
            if (this.tabParams.MG1) {
              this.tabParams.MG1.Item.forEach((item) => {
                switch (item.PropertyName) {
                  case "MG_ZJ1":
                    item.PropertyName = "锚杆直径";
                    break;
                  case "MG_Length1":
                    item.PropertyName = "锚杆长度";
                    break;
                  case "MG_JJ1":
                    item.PropertyName = "锚杆间距";
                    break;
                  case "MG_PJ1":
                    item.PropertyName = "锚杆排距";
                    break;
                }
              });
              //过滤
              this.tabParams.MG1.Item = this.tabParams.MG1.Item.filter(
                (item) => item.PropertyName != "IsMG1"
              );
            }
            if (this.tabParams.MG2) {
              this.tabParams.MG2.Item.some((item) => {
                if (item.PropertyName === "IsMG2" && item.text === "False") {
                  delete this.tabParams.MG2;
                  return true;
                }
              });
            }
            if (this.tabParams.MG2) {
              this.tabParams.MG2.Item.forEach((item) => {
                switch (item.PropertyName) {
                  case "MG_ZJ2":
                    item.PropertyName = "锚杆直径";
                    break;
                  case "MG_Length2":
                    item.PropertyName = "锚杆长度";
                    break;
                  case "MG_JJ2":
                    item.PropertyName = "锚杆间距";
                    break;
                  case "MG_PJ2":
                    item.PropertyName = "锚杆排距";
                    break;
                }
              });
              //过滤
              this.tabParams.MG2.Item = this.tabParams.MG2.Item.filter(
                (item) => item.PropertyName != "IsMG2"
              );
            }
            //GJW
            if (this.tabParams.GJW1) {
              this.tabParams.GJW1.Item.some((item) => {
                if (item.PropertyName === "IsGJW1" && item.text === "False") {
                  delete this.tabParams.GJW1;
                  return true;
                }
              });
            }
            if (this.tabParams.GJW1) {
              this.tabParams.GJW1.Item.forEach((item) => {
                switch (item.PropertyName) {
                  case "GJW_ZJ1":
                    item.PropertyName = "钢筋网直径";
                    break;
                  case "GJW_Length1":
                    item.PropertyName = "钢筋网长度";
                    break;
                }
              });
              //过滤
              this.tabParams.GJW1.Item = this.tabParams.GJW1.Item.filter(
                (item) => item.PropertyName != "IsGJW1"
              );
            }
            if (this.tabParams.GJW2) {
              this.tabParams.GJW2.Item.some((item) => {
                if (item.PropertyName === "IsGJW2" && item.text === "False") {
                  delete this.tabParams.GJW2;
                  return true;
                }
              });
            }
            if (this.tabParams.GJW2) {
              this.tabParams.GJW2.Item.forEach((item) => {
                switch (item.PropertyName) {
                  case "GJW_ZJ2":
                    item.PropertyName = "钢筋网直径";
                    break;
                  case "GJW_Length2":
                    item.PropertyName = "钢筋网长度";
                    break;
                }
              });
              //过滤
              this.tabParams.GJW2.Item = this.tabParams.GJW2.Item.filter(
                (item) => item.PropertyName != "IsGJW2"
              );
            }
            //MS
            if (this.tabParams.MS1) {
              this.tabParams.MS1.Item.some((item) => {
                if (item.PropertyName === "IsMS1" && item.text === "False") {
                  delete this.tabParams.MS1;
                  return true;
                }
              });
            }
            if (this.tabParams.MS1) {
              this.tabParams.MS1.Item.forEach((item) => {
                switch (item.PropertyName) {
                  case "MS_ZJ1":
                    item.PropertyName = "锚索直径";
                    break;
                  case "MS_Length1":
                    item.PropertyName = "锚索长度";
                    break;
                  case "MS_JJ1":
                    item.PropertyName = "锚索间距";
                    break;
                  case "MS_PJ1":
                    item.PropertyName = "锚索排距";
                    break;
                }
              });
              //过滤
              this.tabParams.MS1.Item = this.tabParams.MS1.Item.filter(
                (item) => item.PropertyName != "IsMS1"
              );
            }
            //MS
            if (this.tabParams.MS2) {
              this.tabParams.MS2.Item.some((item) => {
                if (item.PropertyName === "IsMS2" && item.text === "False") {
                  delete this.tabParams.MS2;
                  return true;
                }
              });
            }
            if (this.tabParams.MS2) {
              this.tabParams.MS2.Item.forEach((item) => {
                switch (item.PropertyName) {
                  case "MS_ZJ2":
                    item.PropertyName = "锚索直径";
                    break;
                  case "MS_Length2":
                    item.PropertyName = "锚索长度";
                    break;
                  case "MS_JJ2":
                    item.PropertyName = "锚索间距";
                    break;
                  case "MS_PJ2":
                    item.PropertyName = "锚索排距";
                    break;
                }
              });
              //过滤
              this.tabParams.MS2.Item = this.tabParams.MS2.Item.filter(
                (item) => item.PropertyName != "IsMS2"
              );
            }
            //key变成中文
            var keyMap3 = {
              Sup: "支护形式",
              PT1: "喷砼——一次支护",
              PT2: "喷砼——二次支护",
              MG1: "锚杆——一次支护",
              MG2: "锚杆——二次支护",
              GJW1: "钢筋网——一次支护",
              GJW2: "钢筋网——二次支护",
              MS1: "锚索——一次支护",
              MS2: "锚索——二次支护",
            };
            var objs3 = Object.keys(this.tabParams).reduce((newData, key) => {
              let newKey = keyMap3[key] || key;
              newData[newKey] = this.tabParams[key];
              return newData;
            }, {});
            this.tabParams = objs3;
          } else {
            // console.log("不是sect", this.tabParams);
            if (this.tabParams.SecShotAnchor) {
              delete this.tabParams.SecShotAnchor;
            }
            if (this.tabParams.GJGP) {
              this.tabParams.GJGP.Item.some((item) => {
                if (item.PropertyName === "IsGJGP" && item.text === "False") {
                  delete this.tabParams.GJGP;
                  return true;
                }
              });
            }
            if (this.tabParams.GJGP) {
              this.tabParams.GJGP.Item.forEach((item) => {
                switch (item.PropertyName) {
                  case "GJGP_LB":
                    item.PropertyName = "拱架管棚类别";
                    break;
                  case "GJGP_GG":
                    item.PropertyName = "拱架管棚规格";
                    break;
                  case "GJGP_JJ":
                    item.PropertyName = "拱架管棚间距";
                    break;
                  case "LJGB_JJ":
                    item.PropertyName = "联结钢板间距";
                    break;
                  case "LJGB_HD":
                    item.PropertyName = "联结钢板与脚底板——厚度";
                    break;
                  case "LJGB_LJHD":
                    item.PropertyName = "联结钢板与脚底板——厚度";
                    break;
                  case "LJGB_GG":
                    item.PropertyName = "联结钢板与脚底板规格";
                    break;
                  case "LJGB_LJGG":
                    item.PropertyName = "联结钢板与脚底板规格";
                    break;
                  case "LJGB_SL":
                    item.PropertyName = "联结钢板与脚底板数量";
                    break;
                  case "LJGB_LJSL":
                    item.PropertyName = "联结钢板与脚底板数量";
                    break;
                  case "LJLG_ZJ":
                    item.PropertyName = "连接拉杆直径";
                    break;
                  case "LJLG_LJZJ":
                    item.PropertyName = "连接拉杆直径";
                    break;
                  case "LJLG_JJ":
                    item.PropertyName = "连接拉杆间距";
                    break;
                  case "LJLG_LJJJ":
                    item.PropertyName = "连接拉杆间距";
                    break;
                }
              });
              //过滤
              this.tabParams.GJGP.Item = this.tabParams.GJGP.Item.filter(
                (item) => item.PropertyName != "IsGJGP"
              );
            }
            if (this.tabParams.GJHNT) {
              this.tabParams.GJHNT.Item.some((item) => {
                if (item.PropertyName === "IsGJHNT" && item.text === "False") {
                  delete this.tabParams.GJHNT;
                  return true;
                }
              });
            }
            if (this.tabParams.GJHNT) {
              this.tabParams.GJHNT.Item.forEach((item) => {
                switch (item.PropertyName) {
                  case "GJHNT_ZHHD":
                    item.PropertyName = "钢筋混凝土支护厚度";
                    break;
                  case "GJHNT_Zj":
                    item.PropertyName = "钢筋混凝土主筋";
                    break;
                  case "GJHNT_FJ":
                    item.PropertyName = "钢筋混凝土副筋";
                    break;
                  case "GJHNT_LJ":
                    item.PropertyName = "钢筋混凝土拉筋";
                    break;
                }
              });
              //过滤
              this.tabParams.GJHNT.Item = this.tabParams.GJHNT.Item.filter(
                (item) => item.PropertyName != "IsGJHNT"
              );
            }
            if (this.tabParams.GJW) {
              this.tabParams.GJW.Item.some((item) => {
                if (item.PropertyName === "IsGJW" && item.text === "False") {
                  delete this.tabParams.GJW;
                  return true;
                }
              });
            }
            if (this.tabParams.GJW) {
              this.tabParams.GJW.Item.forEach((item) => {
                switch (item.PropertyName) {
                  case "GJW_ZJ":
                    item.PropertyName = "钢筋网直径";
                    break;
                  case "GJW_Length":
                    item.PropertyName = "钢筋网长度";
                    break;
                }
              });
              //过滤
              this.tabParams.GJW.Item = this.tabParams.GJW.Item.filter(
                (item) => item.PropertyName != "IsGJW"
              );
            }

            if (this.tabParams.MG) {
              this.tabParams.MG.Item.some((item) => {
                if (item.PropertyName === "IsMG" && item.text === "False") {
                  delete this.tabParams.MG;
                  return true;
                }
              });
            }
            if (this.tabParams.MG) {
              this.tabParams.MG.Item.forEach((item) => {
                switch (item.PropertyName) {
                  case "MG_ZJ":
                    item.PropertyName = "锚杆直径";
                    break;
                  case "MG_Length":
                    item.PropertyName = "锚杆长度";
                    break;
                  case "MG_JJ":
                    item.PropertyName = "锚杆间距";
                    break;
                  case "MG_PJ":
                    item.PropertyName = "锚杆排距";
                    break;
                }
              });
              //过滤
              this.tabParams.MG.Item = this.tabParams.MG.Item.filter(
                (item) => item.PropertyName != "IsMG"
              );
            }
            if (this.tabParams.MS) {
              this.tabParams.MS.Item.some((item) => {
                if (item.PropertyName === "IsMS" && item.text === "False") {
                  delete this.tabParams.MS;
                  return true;
                }
              });
            }
            if (this.tabParams.MS) {
              this.tabParams.MS.Item.forEach((item) => {
                switch (item.PropertyName) {
                  case "MS_ZJ":
                    item.PropertyName = "锚索直径";
                    break;
                  case "MS_Length":
                    item.PropertyName = "锚索长度";
                    break;
                  case "MS_JJ":
                    item.PropertyName = "锚索间距";
                    break;
                  case "MS_PJ":
                    item.PropertyName = "锚索排距";
                    break;
                }
              });
              //过滤
              this.tabParams.MS.Item = this.tabParams.MS.Item.filter(
                (item) => item.PropertyName != "IsMS"
              );
            }
            if (this.tabParams.PT) {
              this.tabParams.PT.Item.some((item) => {
                if (item.PropertyName === "IsPt" && item.text === "False") {
                  delete this.tabParams.PT;
                  return true;
                }
              });
            }
            if (this.tabParams.PT) {
              this.tabParams.PT.Item.forEach((item) => {
                switch (item.PropertyName) {
                  case "PT_ZHHD":
                    item.PropertyName = "喷砼支护厚度";
                    break;
                }
              });
              //过滤
              this.tabParams.PT.Item = this.tabParams.PT.Item.filter(
                (item) => item.PropertyName != "IsPt"
              );
            }
            if (this.tabParams.SHNT) {
              this.tabParams.SHNT.Item.some((item) => {
                if (item.PropertyName === "IsSHNT" && item.text === "False") {
                  delete this.tabParams.SHNT;
                  return true;
                }
              });
            }
            if (this.tabParams.SHNT) {
              this.tabParams.SHNT.Item.forEach((item) => {
                switch (item.PropertyName) {
                  case "SHNT_ZHHD":
                    item.PropertyName = "素混凝土支护厚度";
                    break;
                }
              });
              //过滤
              this.tabParams.SHNT.Item = this.tabParams.SHNT.Item.filter(
                (item) => item.PropertyName != "IsSHNT"
              );
            }
            //key变成中文
            var keyMap2 = {
              GJGP: "拱架管棚",
              Sup: "支护形式",
              PT: "喷砼",
              MG: "锚杆",
              GJW: "钢筋网",
              MS: "锚索",
              SHNT: "素混凝土",
              GJHNT: "钢筋混凝土",
            };
            var objs2 = Object.keys(this.tabParams).reduce((newData, key) => {
              let newKey = keyMap2[key] || key;
              newData[newKey] = this.tabParams[key];
              return newData;
            }, {});
            this.tabParams = objs2;
          }
          this.objSelected = true;
          this.arrSelected = false;
          this.showAllItems();
          break;
        case 3: //环境
          this.tabParams = this.Section.EnviParams;
          this.tabParams.Item.forEach((item) => {
            switch (item.PropertyName) {
              case "WYCSWD":
                item.PropertyName = "围岩初始温度";
                break;
              case "JFWD":
                item.PropertyName = "进风温度";
                break;
              case "FLLS":
                item.PropertyName = "风流流速";
                break;
              case "YSRDL":
                item.PropertyName = "岩石热导率λ";
                break;
              case "YSBR":
                item.PropertyName = "岩石比热c";
                break;
              case "YSMD":
                item.PropertyName = "岩石密度γ";
                break;
              case "KJTFSJ":
                item.PropertyName = "矿井通风时间";
                break;
            }
          });
          this.objSelected = false;
          this.arrSelected = true;
          break;
      }
    },
    //面板展开
    showAllItems() {
      // 设置所有折叠面展开
      const open = [];
      for (var i = 0; i < Object.keys(this.tabParams).length; i++) {
        open.push(i);
      }
      this.activeNames = open;
    },
    // 左树查询
    filterNode(value, data) {
      if (!value) return true;
      return data.Name.indexOf(value) !== -1;
    },
    //****点击某一个objId
    handleNodeClick(data, node, obj) {
      this.isActive = data.Index;
      if (data.Section.SecParams) {
        // console.log(data.Section)
        //obj => arr
        this.objSelected = false;
        this.arrSelected = true;
        //给section赋值
        this.Section = JSON.parse(JSON.stringify(data.Section));
        // console.log('click an obj',this.Section);
        this.arrSelected = true;
        this.Section.Basic = JSON.parse(JSON.stringify(this.Section.SecParams));
        this.tabParams = this.Section.Basic.BasicPara;
        //合并数组 断面
        this.Section.SecParams.CalResults.Item = [
          ...this.Section.SecParams.CalResults.Item,
          ...this.Section.SecParams.SecShapePara.Item,
        ];
        delete this.Section.SecParams.BasicPara;
        delete this.Section.SecParams.SecShapePara;
        //合并数组 支护
        this.Section.SupParams.GJGP.Item = [
          ...this.Section.SupParams.GJGP.Item,
          ...this.Section.SupParams.LJGB.Item,
          ...this.Section.SupParams.LJLG.Item,
        ];
        delete this.Section.SupParams.LJGB;
        delete this.Section.SupParams.LJLG;
        if (this.tabParams) {
          this.tabParams.Item.forEach((item) => {
            switch (item.PropertyName) {
              case "SecName":
                item.PropertyName = "断面名称";
                break;
              case "TUCeng":
                item.PropertyName = "图层";
                break;
              case "BSecType":
                item.PropertyName = "断面类型";
                break;
            }
          });
        }
        if (this.tabParams) {
          let filterData = this.tabParams.Item.filter((item) => {
            if (
              item.PropertyName === "断面名称" ||
              item.PropertyName === "图层" ||
              item.PropertyName === "断面类型"
            ) {
              return item;
            }
          });
          this.tabParams.Item = filterData;
        }
        this.tabSelected = 0;
        //显示右侧list
        this.listActivated = true;
        this.warningActivated = false;
        //子组件点击事件，给父组件传id
        //  console.log('8555665',data.Name)
        this.$emit("handleModel", data.Name);
        //多选构件
        if (data.children.length > 0) {
          this.selectArr = []; //多选构件
          this.recursionPlus(data.children);
          this.$emit("handleModel", this.selectArr);
        }
      } else {
        this.warningActivated = true;
        this.listActivated = false;
      }
    },
    //recursionPlus
    recursionPlus(data) {
      // console.log('eeee')
      data.map((item) => {
        // console.log('enter')
        if (item.children.length < 1) {
          this.selectArr.push(item.Name);
          if (item.Section) {
            this.beforeArr.push(item.Section);
          }
        } else {
          this.recursionPlus(item.children);
        }
      });
    },
    //打开树
    handleTreeOpen() {
      this.treeActivated = true;
      this.__init();
    },
    //点击Bimface objectId
    parentHandleclick(objId) {
      this.treeActivated = true;
      if (this.jumpSource === "model") {
        var url = api.file_mim_treeFormat.url + this.fileId;
      } else if (this.jumpSource === "deliverData") {
        var url = api.file_mim_tree_deliverData.url;
      } else {
        var url = api.file_mim_tree.url + this.rowId;
      }
      if (this.treeData.length < 1) {
        //还没请求过
        request
          .get(url, {
            params: this.queryInfo,
          })
          .then((resp) => {
            if (resp.data.code == 200) {
              this.treeData = resp.data.tree;
              this.$nextTick(() => {
                this.$refs.treeDataRef.setCheckedNodes(this.treeData);
              });
              this.nameArr = []; //选中的id数组
              this.recursionName(this.treeData);
              this.$emit("allName", this.nameArr);
              this.recursion(this.treeData, objId);
            } else {
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        //请求过
        this.recursion(this.treeData, objId);
      }
      //锚点
      if (document.querySelector(".light_blue")) {
        this.$nextTick(() => {
          setTimeout(() => {
            //子盒子溢出的高度
            document.querySelector(".tree_box").scrollTop = 0; //动之前的盒子
            var theTop = document
              .querySelector(".light_blue")
              .getBoundingClientRect().top;
            document.querySelector(".tree_box").scrollTop = theTop - 400;
          }, 500);
          // console.log('top',document.querySelector(".tree_box").scrollTop)
        });
      }
    },
    //递归拿到最内
    recursion(tree, objId) {
      tree.map((item) => {
        if (item.children.length < 1) {
          if (item.Name === objId) {
            this.handleNodeClick(item); //含section属性的对象
            this.isActive = item.Index;
          }
        } else {
          this.recursion(item.children, objId);
        }
      });
    },
    //关闭树
    handleTreeClose() {
      this.treeActivated = false;
      this.listActivated = false;
      this.warningActivated = false;
    },
    //关闭列表
    handleListClose() {
      this.listActivated = false;
    },
    //关闭提醒
    handleWarningClose() {
      this.warningActivated = false;
    },
    handleIsActive(label, Index) {
      this.isActive = Index;
    },
  },
};
</script>

<style scoped>
.list_item {
  display: flex;
  justify-content: space-between;
  border-bottom: 0.5px solid #606266;
  width: 100%;
  height: 28px;
  line-height: 28px;
}

.list_name,
.list_text {
  border-right: 0.5px solid #606266;
  width: 50%;
  font-size: 12px;
  padding-left: 5px;
}

.list_name {
  box-sizing: border-box;
  padding-left: 12px;
}

.table_item {
  width: 310px;
}

.table_item:first-child {
  border-top: 0.5px solid #606266;
}

.table_name {
  padding-left: 12px;
}
.table_text {
  padding-left: 12px;
}

.collapse-title {
  flex: 1 0 90%;
  order: 1;
}

.el-collapse-item__header {
  flex: 1 0 auto;
  order: -1;
}

.icon_box {
  position: absolute;
  top: 70px;
  left: 10px;
  /* left: 100px; */
  z-index: 999;
  background-color: #050606;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.model_icon {
  top: 20px;
}
.icon_box img {
  height: 45px;
  width: 30px;
}
.icon_box:hover img {
  content: url(../../assets/images/tree_white.png);
}

.main_left {
  color: #fff;
  background-color: rgba(14, 14, 14, 0.9);
  position: absolute;
  width: 310px;
  height: calc(100vh - 50px);
  top: 50px;
  left: 0px;
  z-index: 1000;
}

.model_main_left {
  top: 0px;
}

.main_right {
  color: #fff;
  background-color: transparent;
  /* background-color: rgba(14, 14, 14, 0.9); */
  position: absolute;
  width: 310px;
  /* height: 430px; */
  height: calc(100vh - 50px);
  top: 50px;
  /* right: 350px; */
  right: 0px;
  z-index: 1000;
}

.main_right_warning {
  background-color: rgba(14, 14, 14, 0.9);
}

.model_main_right {
  top: 0px;
}
.title_box {
  background-color: #050606;
  font-size: 14px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  /* background-color: skyblue; */
}
.tab_box {
  height: 35px;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tab_box > div {
  background-color: rgba(14, 14, 14, 0.9);
  text-align: center;
  width: 23%;
  height: 35px;
  line-height: 35px;
  border-radius: 5px 5px 0 0px;
  cursor: pointer;
}

.tab_selected {
  background-color: #3c3d3e !important;
}

.tree_model {
  margin-right: 7px;
  height: 15px;
  width: 15px;
}
.el-input,
.el-tree {
  background-color: #292a2c;
}

.el-input /deep/ .el-input__inner {
  border-radius: 0px;
  font-size: 12px;
  background-color: rgba(45, 45, 46, 0.9);
  border: 1px #606266 solid;
  border-width: 1px 0px;
  color: #dcdfe6;
  /* border:1px #dcdfe6 solid; */
}

.el-input /deep/ .el-input__icon {
  font-size: 14px;
  line-height: 32px;
}

.tree_box {
  color: #fff;
  width: 310px;
  /* height: 355px; */
  height: calc(100vh - 125px);
  padding-top: 5px;
  overflow-y: auto;
  overflow-x: auto;
  white-space: nowrap;
}

.el-tree {
  color: #fff;
  display: inline-block;
  background-color: transparent;
}

.el-tree /deep/ .el-tree__empty-block {
  width: 305px;
  height: 330px;
}
.list_box {
  color: #fff;
  width: 310px;
  height: calc(100vh - 125px);
  overflow-y: auto;
  overflow-x: auto;
  white-space: nowrap;
  border: 0px;
  background-color: rgba(14, 14, 14, 0.9);
  /* background-color: transparent; */
}

.list_box /deep/ .el-collapse {
  display: inline-block;
  border-width: 0px;
}

.el-collapse /deep/ .el-collapse-item,
.el-collapse /deep/ .el-collapse-item__header,
.el-collapse /deep/ .el-collapse-item__content {
  /* color: #dcdfe6; */
  color: #fff;
  /* background-color: rgba(14, 14, 14, 0.6); */
}

.el-collapse /deep/ .el-collapse-item__content {
  padding: 0;
}

.el-collapse /deep/ .el-collapse-item {
  border-width: 0px !important;
  width: 100%;
}

/* 标题 */
.el-collapse /deep/ .el-collapse-item__header {
  font-size: 12px;
  height: 28px;
  background-color: #3c3d3e;
  /* background-color: rgba(45, 46, 48, 0.8); */
  border: 1px #606266 solid;
  border-width: 1px 0px;
  padding-left: 10px;
  min-width: 310px;
  /* display: inline-block */
}

.el-collapse /deep/ .el-collapse-item__header:first-child {
  /* border-width: 0px 0 0 1px; */
}

/* 展开 */
.el-collapse /deep/ .el-collapse-item__content {
  font-size: 12px;
  padding-left: 0px;
}

.el-collapse /deep/ .el-collapse-item__wrap {
  border-width: 0px;
  background-color: transparent;
}

.tree_box::-webkit-scrollbar,
.list_box::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* <!--修改 滚动条的 下面 的 样式--> */
.tree_box::-webkit-scrollbar-track,
.list_box::-webkit-scrollbar-track {
  background-color: #292a2c;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}
/* <!--修改 滑块 --> */
.tree_box::-webkit-scrollbar-thumb,
.list_box::-webkit-scrollbar-thumb {
  /* background-color: pink; */
  background-color: #848485;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}

.el-tree /deep/ .el-tree-node__label,
.el-tree /deep/ .el-tree-node__content {
  font-size: 12px;
  height: 22px;
  width: 270px;
  /* background-color: rgba(45, 45, 46, 0); */
}

.el-tree /deep/ .el-tree-node:focus > .el-tree-node__content {
  background-color: #292a2c;
}

.el-tree /deep/ .el-tree-node__content:hover {
  background: #292a2c;
}

.el-tree /deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-tree /deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #11dab7 !important;
  border-color: #11dab7 !important;
}

.el-tree /deep/ .el-checkbox__inner:hover {
  border-color: #11dab7 !important;
}
.el-tree /deep/ .el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #11dab7 !important;
}

.light_blue {
  color: #11dab7;
}

.nodata {
  /* background-color: pink; */
  height: 355px;
  width: 305px;
  color: #909297;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nodata_warning {
  font-size: 12px;
}

.nodata_warning > div {
  padding-left: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/documentManagement/modelDetail.vue